import _ from 'lodash';
// import utils from './utils.js';
const presentationDir = require.context('.', true, /\/(config\.js$)/);

let presentations = [];

presentationDir.keys().forEach((key) => {
  /** set to base config */
  let presentationBaseDIr = 'presentation';
  let presentationID = /^\w*/.exec(key.slice(2))[0];
  let presentationPath = `static/${process.env.VUE_APP_MULTIBOOK_TYPE}/${presentationBaseDIr}/${presentationID}`;

  presentations.push(
    _.extend(presentationDir(key).default, {
      id: presentationID,
      presentationPath: presentationPath,
      // pageId,
    })
  );
});

export default presentations;
